import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const LightningRoundSection = ({ lightningRound, onChange }) => (
  <section>
    <div className="section-header flex items-center gap-2 bg-orange-100 py-1.5 px-3">
      <span className="text-sm">⚡</span>
      <span className="text-sm">Lightning Round</span>
    </div>
    <div className="p-3">
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Priority 1</Label>
          <Textarea
            value={lightningRound.priority1}
            onChange={(e) => onChange('priority1', e.target.value)}
            placeholder="First priority..."
            className="mt-0.5 tactical-input text-sm min-h-[50px]"
            data-testid="lightning-priority-1"
          />
        </div>
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Priority 2</Label>
          <Textarea
            value={lightningRound.priority2}
            onChange={(e) => onChange('priority2', e.target.value)}
            placeholder="Second priority..."
            className="mt-0.5 tactical-input text-sm min-h-[50px]"
            data-testid="lightning-priority-2"
          />
        </div>
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Priority 3</Label>
          <Textarea
            value={lightningRound.priority3}
            onChange={(e) => onChange('priority3', e.target.value)}
            placeholder="Third priority..."
            className="mt-0.5 tactical-input text-sm min-h-[50px]"
            data-testid="lightning-priority-3"
          />
        </div>
      </div>
    </div>
  </section>
);
